import React, { FC, useState } from 'react';
import classnames from 'classnames';
import { WearerSummary } from 'src/components/BundleProduct/BundleOptionsProvider';
import { ModalProductInfo } from 'src/components/ProductDetail/ModalProductInfo';
import { DeliveryTab } from 'src/components/ProductDetail/DeliveryTab';
import { WearerBundleDetails } from 'src/queries/__generated__/wearerBundleDetail';
import { MediaEntry } from 'src/types/global-types';

import { BundleSizeGuideAndDetails } from './BundleSizeGuideAndDetails';
import classes from './BundleInformationsAndQuantity.scss';

type Props = {
    currentQty: number;
    maxQty: number;
    bundleInformation?: WearerSummary;
    details?: WearerBundleDetails;
    mediaEntry?: MediaEntry;
    productUrl?: string;
};

export const BundleInformationsAndQuantity: FC<Props> = ({
    currentQty,
    maxQty,
    bundleInformation,
    details,
    mediaEntry,
    productUrl,
}) => {
    const [isOpenProductInfoModal, setIsOpenProductInfoModal] = useState(false);

    const createTip = () => {
        if (currentQty > maxQty) return `You've added too many items - this deal is limited to ${maxQty}`;

        if (currentQty === maxQty)
            return (
                <>
                    Nice one! <img src="../../../static/icons/victory.png" alt="" />
                </>
            );

        if (currentQty === 0) return 'No sizes selected';
        if (currentQty / maxQty <= 0.5) return 'Keep going!';
        if (currentQty / maxQty <= 0.75) return 'Nearly there!';

        return 'Just a little more!';
    };

    return (
        <div
            data-testid="bundleInformationsAndQuantity"
            className={classnames(classes.qtyContainer, {
                [classes.qtyContainerColumn]: Boolean(bundleInformation),
            })}
        >
            {details && (
                <ModalProductInfo
                    isOpenProductInfoModal={isOpenProductInfoModal}
                    closeProductInfoModal={() => setIsOpenProductInfoModal(false)}
                    description={details.description || ''}
                    is24HourDelivery={details.is24HourDelivery}
                    canCustomise={details.canCustomise}
                    mediaEntires={details.mediaEntries}
                    additionalMediaEntry={mediaEntry}
                    productName={details.name}
                    delivery={<DeliveryTab />}
                />
            )}
            <div className={classes.qtyAndName}>
                {bundleInformation && <span className={classes.bundleName}>{bundleInformation.name}</span>}
                <span
                    className={classnames(classes.qtyCounter, {
                        [classes.warning]: currentQty > maxQty,
                        [classes.success]: currentQty === maxQty,
                    })}
                >
                    {currentQty}/{maxQty}
                </span>
            </div>
            <span
                className={classnames(classes.tip, {
                    [classes.warning]: currentQty > maxQty,
                })}
            >
                {createTip()}
            </span>
            <BundleSizeGuideAndDetails
                sizeGuides={details?.sizeGuides}
                details={details}
                setIsOpenProductInfoModal={setIsOpenProductInfoModal}
                productUrl={productUrl || ''}
            />
        </div>
    );
};
